import React, { useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Container,
  Modal,
} from "@mui/material";
import Dashboard from "./dashboard"; // Adjust the import path as necessary
import SettingsView from "./SettingsView";
import TransactionsView from "./TransactionsView";
import LedgerView from "./LedgerView";
import {
  HomeOutlined,
  DescriptionOutlined,
  SettingsOutlined,
  RequestQuoteOutlined,
  ViewListOutlined,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { OnBoarding } from "../components/OnBoarding/OnBoarding";


import useAccelContext from "../contexts/AccelContext";
import ReportView from "./ReportView";

export const AccelView = () => {
  const [value, setValue] = React.useState<number>(0);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const { theme, authErrorState } = useAccelContext();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const tabItems = [
    { icon: <HomeOutlined />, label: "Dashboard" },
    { icon: <ViewListOutlined />, label: "Transactions" },
    { icon: <RequestQuoteOutlined />, label: "Reports" },
    { icon: <DescriptionOutlined />, label: "General ledger" },
    { icon: <SettingsOutlined />, label: "Settings" },
  ];

  if (authErrorState) {
    return null; // or return <></> for an empty fragment
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundColor: theme?.background?.hex,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          alignItems: "center",
          position: "sticky", // Make the bar sticky
          top: 0, // Stick to the top of the viewport
          zIndex: 1000,
          backgroundColor: theme?.background?.hex,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "end",
            backgroundColor: theme?.background?.hex,
          }}
        >
          <Box sx={{ display: { xs: "block", sm: "none", alignItems: "end" } }}>
            <IconButton
              color="inherit"
              aria-label="menu"
              onClick={handleMenuClick}
              sx={{ color: theme?.primary?.hex }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              {tabItems.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => {
                    setValue(index);
                    handleMenuClose();
                  }}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              display: { xs: "none", sm: "flex" },
              color: theme?.secondary?.hex,
              width: "100%",
              pt: 2,
              pb: 2,
              "& .MuiTabs-flexContainer": {
                justifyContent: "flex-end", // Ensure tabs are aligned to the right
              },
              "& .MuiTabs-indicator": {
                backgroundColor: theme?.primary?.hex,
              },
              "& .MuiTabs-scrollButtons": {
                color: theme?.secondary?.hex,
              },
              // Remove default blue background from scroll buttons
              "& .MuiTabScrollButton-root": {
                backgroundColor: "transparent",
              },
            }}
            TabIndicatorProps={{
              style: {
                backgroundColor: theme?.primary?.hex, // Highlight color for the indicator
              },
            }}
          >
            {tabItems.map((item, index) => (
              <Tab
                key={index}
                icon={item.icon}
                iconPosition="start"
                label={item.label}
                sx={{
                  color: theme?.secondary?.hex,
                  fontSize: { xs: 12, sm: 14 },
                  fontFamily: "Helvetica Neue",
                  padding: "5px 8px",
                  minWidth: 0,
                  flexShrink: 0,
                  "&.Mui-selected": {
                    color: theme?.primary?.hex, // Text color when selected
                  },
                  "& .MuiTab-iconWrapper": { mr: { xs: 0, sm: 1 } },
                  "& .MuiTab-labelIcon": {
                    flexDirection: { xs: "column", sm: "row" },
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>
      </Box>

      <Container>
        {value === 0 && (
          <Box
            sx={{
              height: "100%",
              backgroundColor: theme?.background?.hex,
              padding: 5,
            }}
          >
            <Dashboard />
          </Box>
        )}
        {value === 1 && (
          <Box
            sx={{
              height: "100%",
              backgroundColor: theme?.background?.hex,
              padding: 5,
            }}
          >
            <TransactionsView />
          </Box>
        )}
        {value === 2 && (
          <Box
            sx={{
              height: "100%",
              padding: 5,
              backgroundColor: theme?.background?.hex,
            }}
          >
            <ReportView />
          </Box>
        )}
        {value === 3 && (
          <Box
            sx={{
              height: "100%",
              padding: 5,
              backgroundColor: theme?.background?.hex,
            }}
          >
            <LedgerView />
          </Box>
        )}
        {value === 4 && (
          <Box
            sx={{
              height: "100%",
              padding: 5,
              backgroundColor: theme?.background?.hex,
            }}
          >
            <SettingsView />
          </Box>
        )}
      </Container>
    </Box>
  );
};

export default AccelView;
